import { Component, OnInit, AfterViewChecked, Inject } from '@angular/core';
import { ShoppingcartService } from '../shoppingcart.service';
import { Material } from '../material';
import { Order } from '../order';
import { PaymentOption } from '../typeofpayment/billing-options';
import { Router } from '@angular/router';
import { AnswerToCreateOrderRequest } from '../answer-to-create-order-request';
import { ApiRequestService } from '../../shared/api-request-service';
import { InitializePaymentResponse } from '../initialize-payment-response';
import { LoadingService } from '../loading-spinner/loading.service';
import { PaymentRequest } from '../payment-request';
import { PersonalData } from '../contact/personal-data';
import { DeliveryData } from '../typeofdelivery/delivery';
import { Product } from '../product';
import { ProductForCreateOrderRequest } from '../product-for-create-order-request';
import { catchError, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslationService } from '../../translation/translation.service';
import { HttpError } from '../../shared/httperror';
import { GoogleTagManagerService } from '../../google-tag-manager/google-tag-manager.service';
import { ProductList } from './productList';
import { RegistrationForm } from '../../login/registration-form';
import { RegistrationResponse } from '../../login/registration-response';
import { MAT_ICON, TOAST_STATE, ToastmessageService } from '../../toastmessage/toastmessage.service';

@Component({
    selector: 'pw-cartsummary',
    templateUrl: './cartsummary.component.html',
    styleUrls: ['./cartsummary.component.scss']
})
export class CartsummaryComponent implements OnInit {
    totalQuantity = 0;
    totalPrice = 0;
    materials: Material[] = [];
    typeOfDelivery = '';
    deliveryFee = 0;
    order?: Order = {};
    getNewsOrNot = false;
    applyAszf = false;
    answerToCreateOrderRequest?: AnswerToCreateOrderRequest = {};
    orderCreateApiUrl = '/order/create';
    paymentApiUrl = '/order/pay';
    purchaseLimitForFreeDelivery = 10000;
    paymentRequest?: PaymentRequest = {};
    paymentOptions?: string;
    personalData?: PersonalData = {};
    deliveryData?: DeliveryData = {};
    products: ProductForCreateOrderRequest[] = [];
    totalPriceOfBooks = 0;
    language = '';
    errorMessage = '';
    isAszfCheckBoxRed = false;
    orderBackendUrl = '';
    separated = false;
    preOrderedMaterial: Material[] = [];
    preOrderedMaterialHelper: Material[] = [];
    notPreOrderedMaterial: Material[] = [];
    deliveryFeeConstant = 1140;
    productList: ProductList[] = [];
    numberOfDelivery: number = 0;
    registrationObject?: RegistrationForm = {};
    companyName = '';
    taxNumber = 0;
    registrationUrl = '/signup';
    registrationBaseUrl = '';
    wantToSignup = false;
    deliveryFeeSum = 0;

    constructor(
        @Inject('AUTH_BACKEND_URL') private _registrationBaseUrl: string,
        private _router: Router,
        private _shoppingCartService: ShoppingcartService,
        private _apiRequestService: ApiRequestService,
        private _loadingService: LoadingService,
        @Inject('ORDER_BACKEND_URL') private _orderBackendUrl: string,
        private _translateService: TranslationService,
        private _googleTagManagerService: GoogleTagManagerService,
        private _toastMessageService: ToastmessageService
    ) {
        this.orderBackendUrl = _orderBackendUrl;
        this.registrationBaseUrl = _registrationBaseUrl;
    }

    ngOnInit(): void {
        this.materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
        this.personalData = JSON.parse(sessionStorage.getItem('personalData') as string) as PersonalData;
        this.deliveryData = JSON.parse(sessionStorage.getItem('deliveryData') as string) as DeliveryData;
        this.paymentOptions = JSON.parse(sessionStorage.getItem('paymentOption') as string) as string;
        this.totalPrice = JSON.parse(sessionStorage.getItem('totalPrice') as string) as number;
        this.totalQuantity = JSON.parse(sessionStorage.getItem('totalQuantity') as string) as number;
        this.deliveryFee = this.deliveryData.deliveryFee!;
        this.typeOfDelivery = this.deliveryData.deliveryOption!;
        this.separated = JSON.parse(sessionStorage.getItem('separated') as string) as boolean;
        this.productList = JSON.parse(sessionStorage.getItem('productList') as string) as ProductList[];

        //this.addDeliveryFeeToProductsItem();

        this.wantToSignup = JSON.parse(sessionStorage.getItem('wantToSignup') as string) as boolean;
        if (this.wantToSignup) {
            if (sessionStorage.getItem('registrationPassword')) {
                this.registrationObject = JSON.parse(sessionStorage.getItem('registrationPassword') as string) as RegistrationForm;

            }
        }

        if (this.materials.length === 0) {
            this._router.navigateByUrl('/');
        }

        this.totalPriceOfBooks = JSON.parse(sessionStorage.getItem('totalPriceOfBooks') as string) as number;
        this.language = JSON.parse(sessionStorage.getItem('language') as string) as string;
        if (this._shoppingCartService.order) {
            this._shoppingCartService.order.language = this.language;
        }

        this.products = JSON.parse(sessionStorage.getItem('orderProduct') as string) as ProductForCreateOrderRequest[];

        this.calculateDeliveryFeeSum();

        this.calculateTotalPriceAndTotalQuantity();
        this.updateShoppingcartStatus();
        this.collectPreOrderedMaterials();

    }

    calculateDeliveryFeeSum() {

        this.deliveryFeeSum = JSON.parse(sessionStorage.getItem('deliveryFeeSum') as string) as number;
    }

    isDiscountLimitedUntil(materialList: Material[]): boolean {
        return materialList.some(material => material.discountLimitedUntil !== null);

    }

    calculateTotalPriceAndTotalQuantity() {
        this._shoppingCartService.calculateTotalPrice();
        this.materials.forEach((material) => {
            this.totalQuantity += material.quantity!;
            this.totalPrice += material.originalPrice! * material.quantity!;
        });
    }
    updateShoppingcartStatus() {
        const totalPrice: number = JSON.parse(sessionStorage.getItem('totalPrice') as string) as number;
        const totalQuantity: number = JSON.parse(sessionStorage.getItem('totalQuantity') as string) as number;
        this.totalPrice = totalPrice;
        this.totalQuantity = totalQuantity;
    }

    getNewsLetterOrNot() {
        this.getNewsOrNot = !this.getNewsOrNot;
        if (this._shoppingCartService.order) {
            this._shoppingCartService.order.subscribedForNewsletter = this.getNewsOrNot;
        }
        if (this._shoppingCartService.createOrderRequest) {
            this._shoppingCartService.createOrderRequest.subscribedForNewsletter = this.getNewsOrNot;
        }
    }
    applyAszfOnClick() {
        this.applyAszf = !this.applyAszf;
    }

    public get paymentOption(): typeof PaymentOption {
        return PaymentOption;
    }

    createOrderRequestToBackend() {
        this._shoppingCartService.createOrderRequest = {
            personalData: {
                isCompany: this.personalData?.isCompany,
                email: this.personalData?.email,
                companyName: this.personalData?.companyName,
                firstName: this.personalData?.firstName,
                lastName: this.personalData?.lastName,
                phoneNumber: this.personalData?.phoneNumber,
                taxNumber: this.personalData?.taxNumber,
                zipCode: this.personalData?.zipCode,
                settlement: this.personalData?.settlement,
                address: this.personalData?.address
            },
            deliveryData: {
                deliveryAddress: this.deliveryData?.deliveryAddress,
                deliveryOption: this.deliveryData?.deliveryOption,
                deliveryZipCode: this.deliveryData?.deliveryZipCode,
                deliverySettlement: this.deliveryData?.deliverySettlement
            },
            products: this.products,
            totalPriceOfBooks: this.totalPriceOfBooks,
            totalPrice: this.totalPrice + this.deliveryFeeSum + this.deliveryData?.handlingFee!,
            subscribedForNewsletter: this.getNewsOrNot,
            paymentOption: this.paymentOptions,
            language: this.language,
            clientId: JSON.parse(sessionStorage.getItem('clientId') as string),
            separated: this.separated
        };
    }

    goToOrderInformations() {
        //TODO if shopping carts content has been deleted, this code should have been replaced into shopping cart component
        const materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
        if (materials.length === 0) {
            this._router.navigateByUrl('/');
        }
        if (!this.applyAszf) {
            this.errorMessage = 'Kérem fogadja el az ÁSZF-et!';
            this.isAszfCheckBoxRed = true;
        } else {
            if (this.wantToSignup) {
                this.registerUser();
            }
            this.isAszfCheckBoxRed = false;
            this.createOrderRequestToBackend();
            this._apiRequestService
                .sendRequest(this.orderBackendUrl, true, this._shoppingCartService.createOrderRequest, true, this.orderCreateApiUrl)
                .pipe(
                    catchError((error: HttpErrorResponse) => {
                        return throwError(() => {
                            const httpError: HttpError = error.error as HttpError;
                            if (error.status === 422) {
                                alert(this._translateService.translate(httpError.errorMessage!));
                            } else {
                                alert(this._translateService.translate('order.error.general'));
                            }
                            this._router.navigateByUrl('/');
                        });
                    })
                )
                .subscribe((answer) => {
                    this._shoppingCartService.answerToCreateOrderRequest = answer as AnswerToCreateOrderRequest;
                    this.paymentRequest = {
                        customerOrderReference: this._shoppingCartService.answerToCreateOrderRequest?.customerOrderReference,
                        language: this._shoppingCartService.order?.language
                    };
                    if (
                        this._shoppingCartService.order?.paymentOption === 'SIMPLE' &&
                        this._shoppingCartService.answerToCreateOrderRequest?.customerOrderReference !== null
                    ) {
                        sessionStorage.setItem('paymentRequest', JSON.stringify(this.paymentRequest));
                        this._loadingService.show();
                        this._apiRequestService
                            .sendRequest<PaymentRequest | undefined, InitializePaymentResponse>(
                                this.orderBackendUrl,
                                true,
                                this.paymentRequest,
                                true,
                                this.paymentApiUrl
                            )
                            .subscribe((paymentResponse: InitializePaymentResponse) => {
                                if (paymentResponse?.paymentUrl) {
                                    window.location.href = paymentResponse.paymentUrl;
                                } else {
                                    //TODO: handle missing url
                                }
                            });
                    } else {
                        this._router.navigateByUrl('/orderconfirmation');
                    }

                    this._googleTagManagerService.purchase(
                        this.materials,
                        this.totalPrice + this.deliveryFee + this.deliveryData?.handlingFee!,
                        this.deliveryData?.deliveryOption!,
                        0,
                        this._shoppingCartService?.answerToCreateOrderRequest?.customerOrderReference!
                    );
                });

            sessionStorage.removeItem('orderProduct');
            sessionStorage.removeItem('totalPriceOfBooks');
            if (!sessionStorage.getItem('token')) {
                sessionStorage.removeItem('personalData');
            }
            sessionStorage.removeItem('deliveryData');
            sessionStorage.removeItem('paymentOption');
            sessionStorage.removeItem('materials');
            sessionStorage.removeItem('totalQuantity');
            sessionStorage.removeItem('separated');
            sessionStorage.removeItem('separatedOption');
            sessionStorage.removeItem('wantToSignup');
            sessionStorage.removeItem('registrationPassword');
            sessionStorage.removeItem('productList');
            sessionStorage.removeItem('numberOfDelivery');
            sessionStorage.removeItem('deliveryFeeSum');
        }
    }

    collectPreOrderedMaterials() {
        if (this.separated && this.deliveryFee > 0) {
            this.materials.forEach((material) => {
                if (material.hasPreorder) {
                    this.preOrderedMaterial.push(material);
                }
            });
        }
    }

    removeDuplicateElementsFromPreorderMaterial(material: any, key: string) {
        const seen = new Map();
        const result = [];

        for (const item of material) {
            const keyValue = item[key];

            if (!seen.has(keyValue)) {
                seen.set(keyValue, true);
                result.push(item);
            }
        }

        return result;
    }

    generatePreorderedProductList(): Material[] {
        let preorderMaterialList: Material[] = [];
        if (this.hasPreorder()) {
            this.materials.forEach((material) => {
                if (material.hasPreorder) {
                    preorderMaterialList.push(material);
                }
            });
        }
        return preorderMaterialList;
    }
    hasPreorder(): boolean {
        let hasPreorder = false;
        this.materials.forEach((material) => {
            if (material.hasPreorder) {
                hasPreorder = true;
            }
        });
        return hasPreorder;
    }

    createRegistrationObject() {
        if (this.personalData?.isCompany) {
            this.registrationObject!.address = this.personalData.address;
            this.registrationObject!.email = this.personalData?.address;
            this.registrationObject!.firstName = this.personalData?.firstName;
            this.registrationObject!.lastName = this.personalData?.lastName;
            this.registrationObject!.email = this.personalData?.email;
            this.registrationObject!.companyName = this.personalData?.companyName;
            this.registrationObject!.isCompany = this.personalData?.isCompany;
            this.registrationObject!.taxNumber = this.personalData?.taxNumber;
            this.registrationObject!.settlement = this.personalData.settlement;
            this.registrationObject!.zipCode = this.personalData.zipCode;
            this.registrationObject!.subscribedForNewsLetter = this.getNewsOrNot;
            this.registrationObject!.phoneNumber = this.personalData.phoneNumber;
        } else {
            this.registrationObject!.address = this.personalData?.address;
            this.registrationObject!.email = this.personalData?.address;
            this.registrationObject!.firstName = this.personalData?.firstName;
            this.registrationObject!.lastName = this.personalData?.lastName;
            this.registrationObject!.email = this.personalData?.email;
            this.registrationObject!.isCompany = this.personalData?.isCompany;
            this.registrationObject!.settlement = this.personalData?.settlement;
            this.registrationObject!.zipCode = this.personalData?.zipCode;
            this.registrationObject!.subscribedForNewsLetter = this.getNewsOrNot;
            this.registrationObject!.phoneNumber = this.personalData?.phoneNumber;
        }
    }

    registerUser() {
        this.createRegistrationObject();
        this._apiRequestService
            .sendRequest<RegistrationForm | undefined, RegistrationResponse>(
                this.registrationBaseUrl,
                true,
                this.registrationObject,
                true,
                this.registrationUrl
            )
            .subscribe((answer: RegistrationResponse) => {
                //TODO make a component to display that we sended an email with verification link and navigate there instead of navigate home
                if (answer.message === 'Sikeres regisztráció') {
                    //this._router.navigateByUrl('/verificationmessage');
                    this._toastMessageService.displayToastMessage(
                        TOAST_STATE.success,
                        this._translateService.translate('login.verificationRegistration'),
                        MAT_ICON.success
                    );
                    this.dismissError();
                } else {
                    alert(answer.message);
                }
            });
    }
    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 5000);
    }

}

